import { useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import { formReducer, RESET, SET_ERROR, SET_VALUE } from '../reducers/formReducer';

export function useDynamicForm({ initialValues, validators = {} }) {
    const { i18n } = useTranslation();

    const isRtl = i18n.language === 'he';

    const initialState = {
        values: initialValues,
        errors: {},
    };

    const [state, dispatch] = useReducer(formReducer, initialState);

    const setValue = (key, value) => {
        dispatch({ type: SET_VALUE, key, value });
    };

    const validate = () => {
        let hasError = false;
        Object.keys(validators).forEach((key) => {
            const value = state.values[key];
            const error = validators[key](value);
            if (error) {
                hasError = true;
                dispatch({ type: SET_ERROR, key, error });
            }
        });
        return !hasError;
    };

    const reset = () => {
        dispatch({ type: RESET, payload: initialState });
    };

    const bind = (key) => {
        return {
            name: key,
            className: `form-control ${isRtl ? 'text-end' : ''}`,
            value: state.values[key] || '',
            onChange: (e) => setValue(key, e.target.value),
            onBlur: () => {
                const validator = validators[key];
                if (validator) {
                    const error = validator(state.values[key]);
                    dispatch({ type: 'SET_ERROR', key, error });
                }
            },
        };
    };

    return {
        values: state.values,
        errors: state.errors,
        reset,
        validate,
        bind,
    };
}
